import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { COMMENTABLE_AREA_ONBOARDING_CLICKABLE, ELEMENT_ONBOARDING_CLICKABLE } from 'collaboration-sidebar/features/deepCommenting/constants/deepCommentingOnboarding';
import { URANUS_LAYER } from 'HubStyleTokens/sizes'; // Make the div visible for acceptance test handlers to utilise

const VisibleDiv = styled.div.withConfig({
  displayName: "DeepCommentingOnboardingClickables__VisibleDiv",
  componentId: "sc-99uucc-0"
})(["position:absolute;top:0;left:0;z-index:", ";width:1px;height:1px;"], URANUS_LAYER + 1); // These components are used to simulate a click on a commentable area or comment indicator when in the onboarding.
// We simulate as the actual components might be in an iframe that we can't target.

function DeepCommentingOnboardingClickables() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(VisibleDiv, {
      "data-test-id": "fake-clickable-onboarding-element",
      id: ELEMENT_ONBOARDING_CLICKABLE
    }), /*#__PURE__*/_jsx("div", {
      onClick: e => // Do not let the fake click close a real commentable area popover
      e.stopPropagation(),
      id: COMMENTABLE_AREA_ONBOARDING_CLICKABLE
    })]
  });
}

export default DeepCommentingOnboardingClickables;